import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { ParameterType, ToolsService, ToolsView } from '../../_generated';
import { RequestStatusAction } from '../actionstypes/request-status/request-status.actiontype';
import * as ToolIdAction from '../actionstypes/selected-id/tool-id.actiontype';
import { ToolsRequestStatusAction } from '../actionstypes/tools/tools-request-status.actiontype';
import * as ToolsAction from '../actionstypes/tools/tools.actiontype';
import { DataEntryStore } from '../reducers/data-entry.reducer';
import { getDataType } from '../selectors/data-type.selector';
@Injectable()
export class ToolsEffect {
  private readonly actions$ = inject(Actions);
  private readonly toolsService = inject(ToolsService);
  private readonly store = inject<Store<DataEntryStore>>(Store);

  loadTools$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ToolsAction.ToolsAction.Load),
      withLatestFrom(this.store.select(getDataType)),
      exhaustMap(([, dataType]: [ToolsAction.Load, ParameterType]) =>
        this.toolsService.toolsControllerFindAll(dataType).pipe(
          switchMap((tools: ToolsView[]) => [new ToolIdAction.Sync(tools.map((tool) => tool.id)), new ToolsAction.Get(tools)]),
          catchError((error) => of(new RequestStatusAction(ToolsRequestStatusAction.Error, error as Error))),
        ),
      ),
    ),
  );

  successRequestTools$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ToolsAction.ToolsAction.Get),
      mergeMap(() => of(new RequestStatusAction(ToolsRequestStatusAction.Success))),
    ),
  );
}
